import { imageFileToBase64 } from "@/utils/userroutes/loginroutes1.ts";
import React, { useEffect } from "react";
import { IoDocumentOutline } from "react-icons/io5";
import { PiFileJpg, PiFilePdf, PiFilePng } from "react-icons/pi";

interface FilePreviewProps {
  name: string;
  mimetype: string;
  className?: string;
  file?: File;
}

const mime_to_icon: { [key: string]: React.FC<{ className: string }> } = {
  "image/png": PiFilePng,
  "image/jpg": PiFileJpg,
  "application/pdf": PiFilePdf,
  unknown: IoDocumentOutline,
};

const FilePreview = ({ name, mimetype, className, file }: FilePreviewProps) => {
  const Icon = mime_to_icon[mimetype ?? ""] ?? mime_to_icon.unknown;
  const [base64, setBase64] = React.useState<string | null>(null);

  useEffect(() => {
    if (file && mimetype?.startsWith("image"))
      imageFileToBase64(file).then(setBase64);
  }, []);

  return (
    <div
      className={[
        "h-[10em] w-[10em] rounded-md flex flex-col bg-white items-center justify-center relative overflow-hidden",
        className,
      ].join(" ")}
    >
      {!base64 && <Icon className="w-10 h-10 text-color-a2" />}
      {base64 && (
        <img
          src={base64}
          alt={name}
          className="w-full h-full object-cover rounded-md"
        />
      )}
      <span
        className={[
          "block overflow-hidden overflow-ellipsis",
          base64 ? "absolute bottom-0 left-0 w-full text-white" : "",
        ].join(" ")}
        style={
          base64 ? { background: "linear-gradient(#00000092, #000000e6)" } : {}
        }
        title={name}
      >
        {name}
      </span>
    </div>
  );
};

export default FilePreview;
